import React, { Component } from 'react';

import './Spinner.scss';

class Spinner extends Component {

    static defaultProps = {
        message: 'Пожалуйста, подождите'
    }

    componentDidMount() {
        $(document.body).addClass('Spinner-open');
    }

    componentWillUnmount() {
        $(document.body).removeClass('Spinner-open');
    }

    render() {
        return (
            <div className="Spinner">
                <div className="Spinner-overlay"
                    ref="overlay">
                    <div className="Spinner-label">
                        {this.props.message}
                    </div>
                </div>
            </div>
        );
    }

}

export default Spinner;



// WEBPACK FOOTER //
// ./client/components/Spinner/Spinner.js